import { type FC, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import TopBarProgress from "react-topbar-progress-indicator";
import { getCSSVariableValue } from "../../_metronic/assets/ts/_utils";
import type { WithChildren } from "../../_metronic/helpers";
import { MasterLayout } from "../../_metronic/layout/MasterLayout";
import { useAuth } from "../modules/auth";
import { Error404 } from "../modules/errors/components/Error404";
import { routesConfig } from "./routesConfig";

const PrivateRoutes: FC = () => {
	const { currentUser } = useAuth();
	const userRoleId = currentUser?.role_id ?? null;
	const SuspensedView: FC<WithChildren> = ({ children }) => {
		const baseColor = getCSSVariableValue("--bs-primary");
		TopBarProgress.config({
			barColors: {
				"0": baseColor,
			},
			barThickness: 1,
			shadowBlur: 5,
		});
		return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>;
	};

	// Filter routes based on user role
	const accessibleRoutes = routesConfig.filter((route) =>
		userRoleId ? route.allowedRoles.includes(Number(userRoleId)) : false,
	);
	const notAccessibleRoutes = routesConfig.filter(
		(route) => !route.allowedRoles.includes(Number(userRoleId)),
	);
	return (
		<Routes>
			<Route element={<MasterLayout />}>
				{/* {userRoleId == 7 ? (
          <Route path="auth/*" element={<Navigate to="/dashboard" />} />
        ) : (
          <Route path="auth/*" element={<Navigate to="/vistors" />} />
        )} */}

				{/* Dynamically render accessible routes */}
				{accessibleRoutes.map((route) => (
					<Route
						key={route.path}
						path={route.path}
						element={
							<SuspensedView>
								<route.component />
							</SuspensedView>
						}
					/>
				))}
				{notAccessibleRoutes.map((route) => (
					<Route
						key={route.path}
						path={route.path}
						element={<Navigate to="/error/403" />}
					/>
				))}
				<Route path="*" element={<Error404 />} />
			</Route>
		</Routes>
	);
};

export { PrivateRoutes };
